import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div
      className="flex min-h-dvh flex-col items-center justify-center gap-5 p-6 text-center"
      style={{ background: 'var(--bg)' }}
    >
      <span className="text-6xl" aria-hidden="true">🌯</span>
      <div>
        <h1 className="text-2xl font-bold" style={{ color: 'var(--text)' }}>
          Страница не найдена
        </h1>
        <p className="mt-2 text-sm" style={{ color: 'var(--text-muted)' }}>
          Возможно, ссылка устарела или точка ещё не подключена
        </p>
      </div>
      <button
        onClick={() => navigate(-1)}
        className="rounded-xl px-6 py-3 text-sm font-semibold"
        style={{ background: 'var(--accent)', color: 'var(--accent-fg)' }}
      >
        Назад
      </button>
    </div>
  );
}
